import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { colors } from "../../Assets/styles/colors";
import moment from "moment";
import { useTranslate } from '@tolgee/react';

const ConferenceListElement = ({
  data,
  selected,
  handleJoinConference,
  handleSelectConference,
  tick,
}) => {
  const [ongoing, setOngoing] = useState(false);
  const [isStarted, setIsStarted] = useState(false);
  const [joinVisible, setJoinVisible] = useState(false);
  const { t } = useTranslate();

  const title = data.title;
  const description = data.description;
  const safeMoment = (value) => {
    const m = moment(value);
    return m.isValid() ? m : moment();
  };

  const checkOngoing = (startTime, endTime) => {
    const currentTime = moment();
    const startAt = safeMoment(startTime);
    const endAt = endTime ? safeMoment(endTime) : startAt.clone().add(60, "minutes");
    const startAtThreshold = startAt.clone().subtract(5, "minutes");
    const isActiveWindow =
      currentTime.isSameOrAfter(startAtThreshold) && currentTime.isBefore(endAt);

    setOngoing(isActiveWindow);
    setIsStarted(currentTime.isSameOrAfter(startAt));
    setJoinVisible(isActiveWindow);
  };

  const handleJoinMeetingNoPropagation = (e) => {
    e.stopPropagation();
    handleJoinConference(data);
  };

  useEffect(() => {
    checkOngoing(data.start_at, data.end_at);
  }, [data, tick]);

  return (
    <MeetingELementContainer
      selected={selected}
      ongoing={ongoing}
      onClick={() => {
        handleSelectConference(data);
      }}
    >
      <MeetingDetails>
        <Line>
          <MeetingTitle>{title}</MeetingTitle>{" "}
          {joinVisible ? (
            <JoinCell onClick={(e) => handleJoinMeetingNoPropagation(e)}>
              {t('conferences.join_now')}
            </JoinCell>
          ) : (
            <TimeCell>{safeMoment(data.start_at).format("HH:mm")}</TimeCell>
          )}
        </Line>
        <Line>
          <MeetingDescription>{description} </MeetingDescription>
          <DateCell>
            {ongoing
              ? !isStarted
                ? safeMoment(data.start_at).format("HH:mm")
                : t('call_status.ongoing')
              : safeMoment(data.start_at).format("DD.MM.YYYY")}
          </DateCell>
        </Line>
      </MeetingDetails>
    </MeetingELementContainer>
  );
};

export default ConferenceListElement;

const MeetingELementContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  align-items: center;
  padding: 13px 16px;
  border-left: 3px solid
    ${({ selected, theme }) =>
      selected ? theme.menu.selectedTextColor : "transparent"};
  background: ${({ selected, ongoing, theme }) =>
    selected
      ? theme.chat.selectedBackground
      : ongoing
        ? theme.meetingComponent.ongoingMeetingElementBackground
        : theme.menu.background};
  &:hover {
    background: ${({ theme }) => theme.chat.selectedBackground};
  }
`;

const MeetingDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px;
`;
const MeetingTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const MeetingDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const TimeCell = styled.p`
  margin-left: auto;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
`;

const DateCell = styled.p`
  margin-left: auto;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
`;

const JoinCell = styled.p`
  margin-left: auto;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  background-color: ${({ theme }) =>
    theme.meetingComponent.meetingJoinBackground};
  padding: 2px 10px;
  border-radius: 8px;
  white-space: nowrap;
  flex-shrink: 0;
`;
